export default __webpack_public_path__ + "static/media/iloilo_province_seal0.1b0ac9c4.png";